export default __webpack_public_path__ + "static/cercle_vicieux_uw_it-939fa0acbc97699a8e514ab95fe52237.mp4";